import { ColumnDef } from "@tanstack/react-table";
import { CustomerWithReferralsAndPayouts } from "@/customer/customer";

export const ReferralsCol = (): ColumnDef<CustomerWithReferralsAndPayouts> => ({
  id: "referrals_count",
  header: "Referrals",
  accessorFn: (row) => row.referrals.length,
  enableSorting: true,
});
